/**
 * QueryString Context Types
 */

import { ObjectStringMap, WithRouter } from 'found';

export type QueryStringFilters = {
  [K in keyof GQL.ITrackSearchFilters]: NonNullable<GQL.ITrackSearchFilters[K]>;
};

export interface IQueryStringState {
  query?: string;
  filters?: QueryStringFilters;
  taxonomy_query?: GQL.ITaxonomyQuery;
  license_params?: GQL.ILicenseUsageParamsInput[];
  sort?: GQL.ISearchSortOrder;
}

export interface IQueryStringContext extends IQueryStringState {
  addBudgetFilter(budget: GQL.ITrackSearchBudgetFilter): void;
  addTempoFilter(tempo: GQL.IIntegerRangeFilter | undefined): void;
  addSearchFilter(term: SearchFilter, exclude?: boolean): void;
  addTaxonomyQuery(term: SearchFilter): void;
  addSimilarityFilter(trackId: string): void;
  clearFilters(): void;
  clearSearchQuery(): void;
  removeFilter(keyToRemove: QueryStringParam): void;
  removeBudgetFilter(): void;
  removeLicense(): void;
  removeSearchFilter(term: SearchFilter, exclude?: boolean): void;
  removeSimilarityFilter(): void;
  removeTaxonomyQuery(term: SearchFilter): void;
  removeTempoFilter(): void;
  saveLicense(licenseParams: GQL.ILicenseUsageParamsInput[]): void;
  setSearchQuery(searchQuery: string): void;
  setSearchSortOrder(sortOrder: GQL.ISearchSortOrder): void;
}

export enum QueryStringParam {
  Budget = 'budget',
  License = 'license',
  Search = 'search',
  Tempo = 'tempo',
  SortOrder = 'sort',
  Similarity = 'similarity',
}

export interface QueryStringFilter<Input, Output = Input> {
  serialize(input: Input): string;
  unserialize(query: ObjectStringMap): Output;
}

export type ContextAction<T> =
  (...args: [T, SafeEntity<IQueryStringContext>, WithRouter]) => SafeEntity<IQueryStringContext>;
export type SimpleContextAction =
  (...args: [SafeEntity<IQueryStringContext>, WithRouter]) => SafeEntity<IQueryStringContext>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/types.ts